import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageLineReport from '../../components/PageLineReport';

const AnzahlUntervermittler = () => {
    return <PageLineReport title="Anzahl Untervermittler" reportCode={ReportCodes.BrokerNumber} />;
};

export default AnzahlUntervermittler;
